











































































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';
import TriggerPasswordResetRequest from '@/models/Auth/TriggerPasswordReset';

@Component({
  name: 'ResetPassword', components: { Alert }
})
export default class extends GiganautVue {
  
  public username = '';

  get passwordReset() {
      return AppModule.passwordReset;
  }

  async resetPassword() {
    const request = new TriggerPasswordResetRequest();
    request.username = this.username;
    await AppModule.triggerPasswordReset(request);
  }

  async navigateTologin() {
   this.$router.push({ name: PageNames.Login});
  }
}
